import { useWindowDimensions } from 'react-native';
import { LayoutBreakpoints } from '@/constants/LayoutBreakpoints';

export type Layout = 'tabs' | 'sidebar';

/**
 * Hook to determine the current layout based on screen width
 * @returns 'tabs' for mobile, 'sidebar' for tablet/desktop
 */
export const useCurrentLayout = (): Layout => {
  const { width } = useWindowDimensions();
  return width >= LayoutBreakpoints.tablet ? 'sidebar' : 'tabs';
};
